import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ATbutton from '@at.govt.nz/buttons';
import Modal from 'react-modal';
import { ReactComponent as IconClose } from '../../assets/svg/icon-close.svg';
import { Keyboard } from '../../utils/Keyboard';

const AppSelector = '#at-wayfinding .App';
function getParent() {
  return document.querySelector(AppSelector);
}
class Confirm extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired, // - Anything inside the component
    className: PropTypes.string, // - An additional class, optional
    maskClassName: PropTypes.string,
    isOpen: PropTypes.bool,
    disabled: PropTypes.bool, // - disabled the confirm button
    title: PropTypes.string.isRequired, // - Title of the dialog
    onCancel: PropTypes.func, // - onCancel event handler
    onConfirm: PropTypes.func, // - onConfirm event handler
    showCloseButton: PropTypes.bool,
    confirmLabel: PropTypes.string,
    showCancelButton: PropTypes.bool,
    cancelLabel: PropTypes.string,
  };

  static defaultProps = {
    isOpen: false,
    className: '',
    maskClassName: '',
    disabled: false,
    onCancel: () => { /* default empty function */ },
    onConfirm: () => { /* default empty function */ },
    showCloseButton: true,
    confirmLabel: 'Confirm',
    showCancelButton: true,
    cancelLabel: 'Cancel',
  };

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const { isOpen, onCancel } = this.props;
    const parent = getParent();
    if (isOpen && !event.defaultPrevented && parent && !parent.contains(event.target)) {
      event.stopPropagation();
      onCancel();
    }
  }

  _onCloseRequest = () => {
    const { onCancel } = this.props;
    onCancel();
  }

  _onCloseButtonKeyDown = (event) => {
    const { onCancel } = this.props;
    switch (event.keyCode) {
      case Keyboard.ENTER:
      case Keyboard.SPACE:
        event.preventDefault();
        onCancel();
        break;
      default:
        break;
    }
  }

  render() {
    const {
      children, className, disabled = false, isOpen = false, maskClassName, onCancel, onConfirm, title, showCancelButton, showCloseButton, cancelLabel, confirmLabel,
    } = this.props;
    return (
      <Modal
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={this._onCloseRequest}
        contentLabel={title}
        className="confirm"
        overlayClassName={`confirm__mask ${maskClassName}`}
        parentSelector={getParent}
        aria-modal
        aria-labelledby="confirm__title"
      >
        <div
          className={`confirm__container ${className}`}
        >
          <div id="confirm__title" className="confirm__title" tabIndex="-1">{title}</div>
          { showCloseButton
          && (
            <div className="confirm__close-button" tabIndex="0" role="button" onClick={onCancel} onKeyDown={this._onCloseButtonKeyDown} aria-label={`close ${title} dialog`}>
              <IconClose className="confirm__close-icon" />
            </div>
          )}
          { children }
          <div className="confirm__bottom-button-group">
            {showCancelButton && <ATbutton as="secondary" className="confirm__bottom-button confirm__bottom-button--secondary" onClick={onCancel} tabIndex="0">{cancelLabel}</ATbutton>}
            <ATbutton as="primary" className="confirm__bottom-button confirm__bottom-button--primary" onClick={onConfirm} disabled={disabled} tabIndex="0">
              {confirmLabel}
            </ATbutton>
          </div>
        </div>
      </Modal>
    );
  }
}
export default Confirm;
